import React from "react";
import PropTypes from "prop-types";
import { effectStrings } from "./constants";
import { colorPathogenicity } from "../helpers";
import { capitalizeFirstLetter } from "../../../../../common/helpers/helpers";

const VariantsTable = ({ variants, varsomeHost }) => {
  if (variants && variants.length > 0) {
    return (
      <table
        className="tw-p-2.5 tw-bg-blueGray-100 tw-overflow-x-auto tw-w-full"
        data-testid="variants-table"
      >
        <thead>
          <tr>
            <th colSpan="5">
              <h5>Other variants found in individual</h5>
            </th>
          </tr>
          <tr>
            <th className="tw-w-3/20 tw-font-semibold">Variant</th>
            <th className="tw-w-3/20 tw-font-semibold">
              Clinical Classification
            </th>
            <th className="tw-w-3/20 tw-font-semibold">Effect Curator</th>
            <th className="tw-w-3/20 tw-font-semibold">Effect Submitter</th>
            <th className="tw-w-8/20 tw-font-semibold">Comments</th>
          </tr>
        </thead>
        <tbody data-testid="variants-inner-table-body">
          {variants.map((variant, i) => {
            return (
              <tr key={`row-${i}`}>
                <td className="tw-w-3/20">
                  {variant?.variant_info?.map((v, idx) => {
                    const variantUrl = `${varsomeHost}/variant/${v?.variant_id}`;
                    if (v?.variant_notation) {
                      return (
                        <a
                          key={`variant-${idx}`}
                          href={variantUrl}
                          target="_blank"
                          data-testid="variants-table-variant-notation"
                        >
                          {v?.variant_notation}
                        </a>
                      );
                    }
                    return null;
                  })}
                  <br />
                  <small>
                    <a href={variant?.lovd_link} target="_blank">
                      See in LOVD
                    </a>
                  </small>
                </td>
                <td
                  className="tw-w-3/20"
                  data-testid="variants-table-classification-submitter"
                >
                  {variant?.pathogenicity?.clinical_classification_submitter
                    ? colorPathogenicity(
                        variant?.pathogenicity
                          ?.clinical_classification_submitter
                      )
                    : "-"}
                </td>
                <td
                  className="tw-w-3/20"
                  data-testid="variants-table-effect-curator"
                >
                  {variant?.pathogenicity?.effect_curator
                    ? effectStrings[variant?.pathogenicity?.effect_curator] ||
                      variant?.pathogenicity?.effect_curator
                    : "-"}
                </td>
                <td
                  className="tw-w-3/20"
                  data-testid="variants-table-effect-submitter"
                >
                  {variant?.pathogenicity?.effect_submitter
                    ? effectStrings[variant?.pathogenicity?.effect_submitter] ||
                      variant?.pathogenicity?.effect_submitter
                    : "-"}
                </td>
                <td className="tw-w-8/20">
                  {variant?.comments?.length > 0 ? (
                    <div data-testid="variants-table-comments">
                      {variant?.comments?.map((comment, idx) => {
                        return (
                          <div key={idx}>
                            {comment && capitalizeFirstLetter(comment)}
                          </div>
                        );
                      })}
                    </div>
                  ) : (
                    "-"
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  }
  return null;
};

VariantsTable.propTypes = {
  variants: PropTypes.arrayOf(
    PropTypes.shape({
      comments: PropTypes.arrayOf(PropTypes.string),
      is_current: PropTypes.bool,
      is_lifted_over: PropTypes.bool,
      lovd_link: PropTypes.string,
      pathogenicity: PropTypes.shape({
        clinical_classification_submitter: PropTypes.string,
        clinical_classification_curator: PropTypes.string,
        effect_submitter: PropTypes.string,
        effect_curator: PropTypes.string,
        effect_symbol: PropTypes.string,
      }),
      variant_info: PropTypes.arrayOf(
        PropTypes.shape({
          variant_id: PropTypes.string,
          variant_notation: PropTypes.string,
        })
      ),
    })
  ),
  varsomeHost: PropTypes.string,
};

VariantsTable.defaultProps = {
  variants: [],
  varsomeHost: null,
};

export default VariantsTable;
